import { useState } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import runCalculator from '../api/runCalculator'

const calculatorType = 'Isplative kvote i broj kombinacija'

const category = 'systems'
const slug = 'profitable-odds'

// Format an API number into the same 2-decimal string the local logic produced.
const fmt2 = (val) =>
  isFinite(val) && val !== '' && val !== null ? Number(val).toFixed(2) : '0.00'

const IsplativeKvote = () => {
  const [error, setError] = useState(false)
  const [apiError, setApiError] = useState('')
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [showInputArea, setShowInputArea] = useState(true)

  const [data, setData] = useState({
    values: {
      sysParams: ['', ''],
    },
  })

  // Initial results match the empty-input render byte-for-byte.
  const [results, setResults] = useState({
    minQ: '0.00',
    minPct: '',
    totalComb: '0',
  })

  const clearFields = () => {
    setData({ values: { sysParams: ['', ''] } })
    setResults({ minQ: '0.00', minPct: '', totalComb: '0' })
    setApiError('')
    setDisabled(true)
  }

  // sysParams[0] = required hits (conditional), sysParams[1] = number of pairs (total).
  const buildBody = () => {
    const [conditional, total] = data.values.sysParams.map((v) => parseFloat(v))
    return { conditional, total }
  }

  // Explicit results action: fetch from the metered API once, then map the
  // English response back into the same { minQ, minPct, totalComb } shape the
  // JSX already consumes.
  const handleShowResults = async () => {
    setLoading(true)
    setApiError('')

    try {
      const output = await runCalculator(category, slug, buildBody())
      const [k, n] = data.values.sysParams.map(Number)

      setResults({
        minQ: fmt2(output.minProfitableOdds),
        minPct: k && n ? fmt2(output.minPercentagePct) : '',
        totalComb: String(output.totalCombinations),
      })
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className={classesK.container}>
        <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />

        <div className={classesK.contentContainer}>
          {apiError && <div className={classesK.errorMessage}>{apiError}</div>}
          <div className={classesK.sectionTitle}>
            Upis podataka{' '}
            <button
              className={classesK.calcButton}
              onClick={handleShowResults}
              disabled={loading}
            >
              {loading ? 'Učitavanje...' : 'Prikaži rezultate'}
            </button>
          </div>

          <OddsCalculator
            data={data.values}
            setData={setData}
            field={'sysParams'}
            labelPrefix={[
              'Upiši broj traženih pogodaka u sistemu',
              'Broj parova u sistemu',
            ]}
            header='Podaci o sistemu'
            type={['number', 'number']}
            step={['1', '1']}
            min={['1', '1']}
            rows={2}
            setError={setError}
          />
          <ResultsSection
            results={[results.minQ]}
            subtitle={'Min. isplativa kvota  po paru'}
            names={['KVOTA']}
            rows={1}
            allowNegative={true}
          />
          <ResultsSection
            subtitle={['Minimalni procenat (%) pogođenih parova']}
            names={['MIN %']}
            results={[results.minPct]}
            withPercent={true}
            allowNegative={true}
          />
          <ResultsSection
            subtitle={['Ukupan broj kombinacija za odabrani sistem']}
            names={['BR. KOMBINACIJA']}
            results={[results.totalComb]}
            rows={1}
            allowNegative={true}
          />
        </div>
      </div>
    </>
  )
}

export default IsplativeKvote
